export default "__VITE_ASSET__lVp4JFcF__"